import React from 'react'
import PropTypes from 'prop-types'

const BOX_CLASSES = 'tw:rounded! tw:border tw:border-solid'

const TITLE_CLASSES = 'tw:m-0! tw:text-ds-neutral-highest tw:text-lg! tw:font-medium! tw:leading-tight'

const HEADER_CLASSES = 'tw:flex tw:justify-between tw:items-center tw:px-5 tw:py-3 '
  + 'tw:bg-gray-100 tw:border-b tw:border-solid tw:border-ds-neutral-lowest'

const Card = ({ children, headerRight, plainHeader, title }) => {
  if (plainHeader) {
    return (
      <div className="tw:ds-card tw:p-6">
        <div className="tw:flex tw:flex-col tw:gap-3 tw:lg:flex-row tw:lg:items-center tw:lg:justify-between">
          <h3 className={TITLE_CLASSES}>{title}</h3>
          {headerRight}
        </div>
        {children}
      </div>
    )
  }

  return (
    <div
      className={`${BOX_CLASSES} tw:flex tw:flex-col tw:bg-white tw:overflow-hidden `
        + 'tw:border-ds-neutral-lowest'}
    >
      <div className={HEADER_CLASSES}>
        <h3 className={TITLE_CLASSES}>{title}</h3>
        {headerRight}
      </div>
      {children}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  headerRight: PropTypes.node,
  plainHeader: PropTypes.bool,
  title: PropTypes.string.isRequired
}

Card.defaultProps = {
  headerRight: null,
  plainHeader: false
}

export default Card
